import { DISABLE_TELEPHONE, SHOW_PHONE_OPT_OUT_CHECKBOX} from './PersonalInformationPageConstants';

export default (state = {
    optOutChecked: false,
    showPhoneOptOutCheckbox: false
}, action) => {
    switch (action.type) {
        case DISABLE_TELEPHONE:
            return Object.assign({}, state, {
                optOutChecked: action.payload
            });
        case SHOW_PHONE_OPT_OUT_CHECKBOX:
            return Object.assign({}, state, {
                showPhoneOptOutCheckbox: action.payload
            });
        default:
            return state;
    }
};
